import { PrintButton } from 'src/features/supplier/components/InvoicePrint/ModalInvoicePrint/styles'
import styled from 'styled-components'

interface DanfeContainerProps{
  allowPrinting: boolean
}

export const DanfeContainer = styled.div<DanfeContainerProps>`
  min-width: 886px; ;
  margin: 16px;
  
  @media print{
    display: ${(props) => (props.allowPrinting ? 'block' : 'none')};
  }
`

export const LoaderWeapper = styled.div`
  width: 886px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
`

export const CustomPrintButton = styled(PrintButton)`
  margin-top: 16px;
`
